import type { Logger } from '@devhacker/shared/libs/logger';
import type { IAdminActions } from '~/types/api/admin-actions';
import { API_ADMIN_ACTIONS, API_TIMEOUT } from '~/constants/config';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): IAdminActions => {
  const adminActionsFetch = createAxiosLikeFetch({
    baseURL: API_ADMIN_ACTIONS,
    timeout: API_TIMEOUT,
    credentials: 'include',
    ...createLoggerInterceptors($logger, 'admin-actions'),
  });

  return {
    refreshAppbox(postId, url) {
      return adminActionsFetch('refresh-appbox', {
        method: 'POST',
        body: { postId, url },
      });
    },
  };
};
